import { render, staticRenderFns } from "./DashboardKpi.vue?vue&type=template&id=33c038fc&scoped=true&"
import script from "./DashboardKpi.vue?vue&type=script&lang=ts&"
export * from "./DashboardKpi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c038fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c038fc')) {
      api.createRecord('33c038fc', component.options)
    } else {
      api.reload('33c038fc', component.options)
    }
    module.hot.accept("./DashboardKpi.vue?vue&type=template&id=33c038fc&scoped=true&", function () {
      api.rerender('33c038fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/charts/DashboardKpi.vue"
export default component.exports